module.exports = __webpack_public_path__ + "img/boss-small.62ed1ce0.png";